import { useState, useEffect, Fragment } from "react";

function BokehPopOut() {
  const [plotData, setPlotData] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    if (plotData) {
      let element = document.getElementById("waveform");
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
      window.Bokeh.embed.embed_item(plotData, "waveform");
    }
  }, [plotData]);

  useEffect(() => {
    const plotData = localStorage.getItem("plotData");
    console.log(plotData);
    if (plotData === null) {
      setError(
        "No local storage data, click load plot on the device mangement pane"
      );
    } else {
      setPlotData(JSON.parse(plotData));
    }
  }, []);

  return (
    <Fragment>
      <div className="bokehcontainer">
        <div id="waveform" className="bokehpop">
          {error}
        </div>
      </div>
    </Fragment>
  );
}

export default BokehPopOut;
